import { NO_DATA_SIGN } from "app/filters/const";
import { absFilter, isNumberAndNotNan, numberFilter } from "app/filters/ngFilters";

const PERCENTAGE_LIMIT = 5000;
const PERCENTAGE_MULTIPLIER = 100;
const SMALL_PERCENTAGE_THRESHOLD = 0.1;
const DECIMAL_THRESHOLD = 10;
const SMALL_DECIMAL_PLACES = 1;
const LARGE_DECIMAL_PLACES = 0;

export const formatPercentageWithDynamicPrecision = (value: number, limit = PERCENTAGE_LIMIT): string => {
    if (!isNumberAndNotNan(value) || value === undefined) {
        return NO_DATA_SIGN;
    }

    const absValue = absFilter()(value);

    const percentageValue = absValue * PERCENTAGE_MULTIPLIER;

    if (percentageValue > limit) {
        return `>${limit}%`;
    }

    if (percentageValue > 0 && percentageValue < SMALL_PERCENTAGE_THRESHOLD) {
        return `${SMALL_PERCENTAGE_THRESHOLD}%`;
    }

    const decimalPlaces = percentageValue < DECIMAL_THRESHOLD ? SMALL_DECIMAL_PLACES : LARGE_DECIMAL_PLACES;
    const roundedValue = Math.round(percentageValue * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
    const formattedValue = numberFilter()(roundedValue, decimalPlaces);

    return `${formattedValue}%`;
};

const isValidPosition = (pos: number | undefined) => typeof pos === "number" && pos > -1;

export const formatPositionChange = (Position: number, PreviousPosition: number) => {
    const hasPosition = isValidPosition(Position);
    const hasPreviousPosition = isValidPosition(PreviousPosition);

    const change = hasPosition && hasPreviousPosition ? PreviousPosition - Position : 0;

    let changeState: "new" | "lost" | "nochange" | "nodata" | undefined;

    if (!hasPreviousPosition && hasPosition) {
        changeState = "new";
    } else if (hasPreviousPosition && !hasPosition) {
        changeState = "lost";
    } else if (!hasPreviousPosition && !hasPosition) {
        changeState = "nodata";
    } else if (change === 0) {
        changeState = "nochange";
    }

    const value = {
        change,
        changeState,
    };

    const formattedValue = change !== 0 ? Math.abs(change).toString() : "0";

    return { value, formattedValue };
};
